/**
 * Cold Culture-style quick add (plus icon):
 * - Click plus:
 *   - If one-size: add to cart (AJAX) + open drawer/modal based on theme config.
 *   - If multi-size: opens an inline size picker overlay.
 * - Click a size: adds that variant to cart and closes the overlay.
 *
 * Touch devices: taps are handled on `touchend` for a snappy feel, but ONLY when
 * the touch was a genuine tap (see "Tap vs. scroll detection" below). Scrolling
 * or swiping across the "+" / size buttons never adds anything to the cart.
 */
(function () {
  'use strict';

  // Product cards appear in different section layouts (grid, sliders, featured blocks).
  // Use a broad selector so quick-add works everywhere.
  var CARD_SELECTOR = '.product-loop__item, [data-card]';
  var OVERLAY_SELECTOR = '.cc-sizeOverlay';
  var TOGGLE_SELECTOR = 'button[data-open-size-overlay][data-quick-add]';
  var SWATCH_SELECTOR = 'button.cc-sizeOverlay__btn[data-variant-id]';
  var CLOSE_SELECTOR = '.cc-sizeOverlay__close';

  function getCartConfig() {
    try {
      var el = document.querySelector('#cart-config');
      if (el && el.textContent) {
        return JSON.parse(el.textContent);
      }
    } catch (err) {
      // fall through to defaults
    }

    // Safe defaults if the theme config isn't present for some reason.
    return {
      cart_action: 'drawer',
      cart_type: 'drawer',
      cart_icon: 'bag',
      cart_quantity: true,
      cart_currency: true,
      money_format: '${{amount}}'
    };
  }

  function parseVariantId(value) {
    if (!value) return null;
    var n = parseInt(String(value), 10);
    return Number.isFinite(n) ? n : null;
  }

  function buildTempAddForm(variantId, quantity) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';

    var idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = String(variantId || '');
    form.appendChild(idInput);

    var qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = String(quantity || 1);
    form.appendChild(qtyInput);

    // WAU.AjaxCart.addToCart expects a ".js-ajax-submit" element to exist in the
    // provided context. We add a hidden one here so we can reuse the theme's
    // Ajax cart pipeline from collection cards.
    var submit = document.createElement('input');
    submit.type = 'submit';
    submit.className = 'js-ajax-submit';
    var words = window.RynorStrings || {};
    submit.value = words.add || 'Add';
    submit.setAttribute('data-adding', words.adding || 'Adding…');
    submit.setAttribute('data-added', words.added || 'Added');
    submit.style.display = 'none';
    form.appendChild(submit);

    // Some error paths expect an error container.
    var err = document.createElement('div');
    err.className = 'js-error-msg';
    err.style.display = 'none';
    form.appendChild(err);

    return form;
  }

  function closest(el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);
    // Very small fallback (old browsers)
    while (el && el.nodeType === 1) {
      if (matches(el, selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function matches(el, selector) {
    var fn = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    return fn ? fn.call(el, selector) : false;
  }

  function closeOverlay(card) {
    if (!card) return;
    var overlay = card.querySelector(OVERLAY_SELECTOR);
    var toggle = card.querySelector(TOGGLE_SELECTOR);
    if (overlay) {
      overlay.classList.remove('is-open');
      card.classList.remove('cc-sizeOverlay-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllOverlays(exceptCard) {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      if (exceptCard && cards[i] === exceptCard) continue;
      closeOverlay(cards[i]);
    }
  }

  function openOverlay(card) {
    if (!card) return;
    var overlay = card.querySelector(OVERLAY_SELECTOR);
    var toggle = card.querySelector(TOGGLE_SELECTOR);
    if (!overlay) return;

    closeAllOverlays(card);
    overlay.classList.add('is-open');
    card.classList.add('cc-sizeOverlay-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function setButtonLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  // Size swatch feedback (Cold Culture-style): dots while loading, check when added
  function setSizeSwatchState(btn, state) {
    if (!btn) return;

    // Capture original label once
    if (!btn.dataset.ccLabel) {
      btn.dataset.ccLabel = (btn.textContent || '').trim();
    }

    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.classList.remove('is-added');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = '…';
      return;
    }

    if (state === 'added') {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.removeAttribute('aria-busy');
      btn.disabled = true;
      btn.textContent = '✓';
      return;
    }

    // idle / reset
    btn.classList.remove('is-loading');
    btn.classList.remove('is-added');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    btn.textContent = btn.dataset.ccLabel || '';
  }

  function clearCardTimers(card) {
    if (!card) return;
    var timers = card.__ccSizeOverlayTimers;
    if (!timers || !timers.length) return;
    try {
      timers.forEach(function(t) { clearTimeout(t); });
    } catch (e) {}
    card.__ccSizeOverlayTimers = [];
  }

  function scheduleCardTimer(card, fn, delay) {
    var t = setTimeout(fn, delay);
    if (card) {
      card.__ccSizeOverlayTimers = card.__ccSizeOverlayTimers || [];
      card.__ccSizeOverlayTimers.push(t);
    }
    return t;
  }


  function showCartUI(config) {
    if (!config) config = getCartConfig() || {};
    try {
      if (window.WAU && WAU.AjaxCart) {
        if (config.cart_action === 'drawer' && typeof WAU.AjaxCart.showDrawer === 'function') {
          WAU.AjaxCart.showDrawer(config);
        } else if (config.cart_action === 'modal_cart' && typeof WAU.AjaxCart.showModal === 'function') {
          WAU.AjaxCart.showModal(config);
        } else if (config.cart_action === 'added' && typeof WAU.AjaxCart.showAdded === 'function') {
          WAU.AjaxCart.showAdded(config);
        }
      }
    } catch (err) {
      // noop
    }
  }

  async function addVariantToCart(variantId, card, btnToLock) {
    var id = parseVariantId(variantId);
    if (!id) return;

    var config = getCartConfig() || {};
    var isSizeSwatch = !!(btnToLock && btnToLock.matches && btnToLock.matches(SWATCH_SELECTOR));

    // Cold Culture-style feedback timing
    var startedAt = Date.now();
    var MIN_DOTS_MS = 350;
    var CHECK_BEFORE_CART_MS = 150;
    var CLOSE_AFTER_CHECK_MS = 950;

    // If a previous add scheduled timers on this card, clear them first
    clearCardTimers(card);

    if (isSizeSwatch) {
      setSizeSwatchState(btnToLock, 'loading');
    } else {
      setButtonLoading(btnToLock, true);
    }

    try {
      var added = false;

      /*
        Preferred: use the theme's ThemeCart helper.
        This keeps the cart state + drawer in sync.

        IMPORTANT: We do NOT call WAU.AjaxCart.addToCart() here because it expects a
        full DOM context (buttons/spinners/messages). On collection grids we only
        have a lightweight trigger, which can cause the theme addToCart handler to
        throw and stop the add entirely.
      */
      if (window.WAU && WAU.ThemeCart) {
        try {
          if (typeof WAU.ThemeCart.addItem === 'function') {
            await WAU.ThemeCart.addItem(id, { quantity: 1 });
            added = true;
          } else if (typeof WAU.ThemeCart.addItemFromForm === 'function') {
            var form = buildTempAddForm(id, 1);
            await WAU.ThemeCart.addItemFromForm(form);
            added = true;
          }
        } catch (e) {
          // fall back to /cart/add.js below
          console.warn('[cc-size-overlay] ThemeCart add failed, falling back', e);
        }
      }

      // Fallback: standard Shopify endpoint
      if (!added) {
        var params = new URLSearchParams();
        params.append('id', String(id));
        params.append('quantity', '1');
        var res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
          credentials: 'same-origin',
          body: params.toString(),
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await res.json();
      }

      // Refresh drawer/modal contents + cart count (best effort)
      try {
        if (window.WAU && WAU.ThemeCart && typeof WAU.ThemeCart.getCart === 'function' && WAU.AjaxCart && typeof WAU.AjaxCart.updateView === 'function') {
          var cart = await WAU.ThemeCart.getCart();
          await WAU.AjaxCart.updateView(config, cart);
        }
      } catch (e) {}

      // Notify any custom listeners
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {}

      // Cold Culture-style timing: keep the overlay visible.
      if (isSizeSwatch) {
        var elapsed = Date.now() - startedAt;
        var delayToCheck = Math.max(0, MIN_DOTS_MS - elapsed);

        // 1) show check mark (briefly) when the add completes
        scheduleCardTimer(card, function () {
          setSizeSwatchState(btnToLock, 'added');
        }, delayToCheck);

        // 2) open cart shortly after the check mark appears
        scheduleCardTimer(card, function () {
          showCartUI(config);
        }, delayToCheck + CHECK_BEFORE_CART_MS);

        // 3) close overlay after the check mark has been visible for a moment
        scheduleCardTimer(card, function () {
          setSizeSwatchState(btnToLock, 'idle');
          closeOverlay(card);
        }, delayToCheck + CLOSE_AFTER_CHECK_MS);
      } else {
        // Non-size actions behave as before
        showCartUI(config);
      }
    } catch (err) {
      console.warn('[cc-size-overlay] addVariantToCart failed', err);
      if (isSizeSwatch) {
        setSizeSwatchState(btnToLock, 'idle');
      }
    } finally {
      if (!isSizeSwatch) {
        setButtonLoading(btnToLock, false);
      }
    }
  }

  function getOverlayDefaultVariantId(overlay, card) {
    // Prefer the first size swatch inside the overlay (when present)
    if (overlay) {
      var btn = overlay.querySelector(SWATCH_SELECTOR);
      if (btn) return parseVariantId(btn.getAttribute('data-variant-id'));
    }

    // If there's no overlay, fall back to the product card's default variant
    if (card) {
      var toggle = card.querySelector(TOGGLE_SELECTOR);
      if (toggle) {
        var fromData = parseVariantId(toggle.getAttribute('data-default-variant'));
        if (fromData) return fromData;
      }
    }

    // Fallback to the hidden /cart/add form variant ID if present
    if (card) {
      var form = card.querySelector('form[action^="/cart/add"]');
      if (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) return parseVariantId(input.value);
      }
    }
    return null;
  }

  function handleToggleClick(e, toggleBtn) {
    var card = closest(toggleBtn, CARD_SELECTOR);
    if (!card) return;

    // Single-variant products: add directly using the variant id on the toggle.
    var singleVariantId = toggleBtn.getAttribute('data-single-variant');
    if (singleVariantId) {
      addVariantToCart(singleVariantId, card, toggleBtn);
      return;
    }

    var overlay = card.querySelector(OVERLAY_SELECTOR);
    if (!overlay) {
      // No overlay markup – still try to add the default variant.
      var fallbackId = getOverlayDefaultVariantId(null, card);
      if (fallbackId) addVariantToCart(fallbackId, card, toggleBtn);
      return;
    }

    var isOneSize = overlay.getAttribute('data-one-size') === 'true';
    if (isOneSize) {
      var oneSizeVariantId = getOverlayDefaultVariantId(overlay, card);
      if (oneSizeVariantId) {
        addVariantToCart(oneSizeVariantId, card, toggleBtn);
      }
      return;
    }

    var isOpen = overlay.classList.contains('is-open');
    if (isOpen) closeOverlay(card);
    else openOverlay(card);
  }

  function handleSwatchClick(e, swatchBtn) {
    if (swatchBtn.disabled || swatchBtn.getAttribute('aria-disabled') === 'true') return;

    var card = closest(swatchBtn, CARD_SELECTOR);
    if (!card) return;

    var overlay = card.querySelector(OVERLAY_SELECTOR);
    var variantId = parseVariantId(swatchBtn.getAttribute('data-variant-id'));
    if (!variantId) return;

    // Visual selected state (underline)
    if (overlay) {
      var all = overlay.querySelectorAll('button.cc-SizeSwatch');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-selected');
    }
    swatchBtn.classList.add('is-selected');

    addVariantToCart(variantId, card, swatchBtn);
  }

  // ---------------------------------------------------------------------------
  // Tap vs. scroll detection
  //
  // Why this exists: `touchend` fires when a finger lifts after ANY touch,
  // including a scroll or swipe, and its target is the element the finger first
  // landed on. So a scroll that merely *started* on the "+" (or on a size
  // button) used to be treated as a tap and added the item to the cart.
  //
  // A touch now only counts as a tap when ALL of these are true:
  //   - exactly one finger was used (no pinch / multi-touch)
  //   - the finger stayed put (moved no more than TAP_MAX_MOVE_PX)
  //   - nothing on the page scrolled while the finger was down
  //   - the page wasn't already scrolling when the finger landed (touching a
  //     moving page just stops it; phones don't turn that into a click either)
  // Anything else is ignored here and left to the browser, which does not
  // generate a `click` for scrolls/swipes.
  // ---------------------------------------------------------------------------
  var TAP_MAX_MOVE_PX = 10;    // finger may wobble this much and still be a tap
  var SCROLL_SETTLE_MS = 200;  // a touch this soon after a scroll = "stop the scroll", not a tap

  var touchInfo = null;        // the touch in progress (null = none, or not a tap)
  var lastScrollAt = 0;        // when anything on the page last scrolled

  function onGlobalTouchStart(e) {
    var touches = e.touches;
    if (!touches || touches.length !== 1) {
      touchInfo = null; // multi-finger gestures (pinch-zoom etc.) are never taps
      return;
    }
    touchInfo = {
      x: touches[0].clientX,
      y: touches[0].clientY,
      notATap: (Date.now() - lastScrollAt) < SCROLL_SETTLE_MS
    };
  }

  function onGlobalTouchMove(e) {
    if (!touchInfo || touchInfo.notATap) return;
    var t = e.touches && e.touches[0];
    if (!t) return;
    if (Math.abs(t.clientX - touchInfo.x) > TAP_MAX_MOVE_PX ||
        Math.abs(t.clientY - touchInfo.y) > TAP_MAX_MOVE_PX) {
      touchInfo.notATap = true;
    }
  }

  function onGlobalTouchCancel() {
    touchInfo = null;
  }

  // `scroll` doesn't bubble, so this is registered in the capture phase to also
  // catch scrolling inside carousels and other scrollable containers.
  function onAnyScroll() {
    lastScrollAt = Date.now();
    if (touchInfo) touchInfo.notATap = true;
  }

  // Call once per touchend. Returns true only for a genuine tap.
  function isGenuineTap(e) {
    var info = touchInfo;
    touchInfo = null;
    if (!info || info.notATap) return false;
    if (e.touches && e.touches.length) return false; // another finger is still down
    var t = e.changedTouches && e.changedTouches[0];
    if (t && (Math.abs(t.clientX - info.x) > TAP_MAX_MOVE_PX ||
              Math.abs(t.clientY - info.y) > TAP_MAX_MOVE_PX)) {
      return false;
    }
    return true;
  }

  // On some mobile browsers a tap can yield both a `touchend` *and* a
  // synthetic `click`. If we handle the action on `touchend`, we should ignore
  // the following synthetic click to prevent double-actions or requiring a
  // second tap.
  var ignoreClickUntil = 0;

  function handleGlobalInteraction(e) {
    var target = e.target;
    if (!target) return;

    // Handle size selection clicks first
    var swatchBtn = closest(target, SWATCH_SELECTOR);
    if (swatchBtn && closest(swatchBtn, OVERLAY_SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      handleSwatchClick(e, swatchBtn);
      return true;
    }

    // Close button inside overlay
    var closeBtn = closest(target, CLOSE_SELECTOR);
    if (closeBtn && closest(closeBtn, OVERLAY_SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeAllOverlays(null);
      return true;
    }

    // If the click is inside the overlay (but not on a swatch/close), ignore it.
    if (closest(target, OVERLAY_SELECTOR)) return false;

    // Toggle (plus) click
    var toggleBtn = closest(target, TOGGLE_SELECTOR);

    if (toggleBtn) {
      var card = closest(toggleBtn, CARD_SELECTOR);
      if (!card) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      handleToggleClick(e, toggleBtn);
      return true;
    }

    // Outside click closes any open overlays
    closeAllOverlays(null);
    return false;
  }

  function onGlobalClick(e) {
    // Ignore the synthetic click that can follow a handled touch interaction.
    if (e.type === 'click' && Date.now() < ignoreClickUntil) return;
    handleGlobalInteraction(e);
  }

  function onGlobalTouchEnd(e) {
    // Scrolls, swipes, pinches and "touch to stop a moving page" all end in a
    // touchend too. Only a genuine tap may add to the cart / open the size picker.
    // (Ignored touches are deliberately left untouched so scrolling stays smooth
    // and the browser's own click handling still applies.)
    if (!isGenuineTap(e)) return;

    var handled = handleGlobalInteraction(e);
    if (handled) {
      // Give the synthetic click a moment to arrive, then allow clicks again.
      ignoreClickUntil = Date.now() + 450;
    }
  }

  // Close any open overlays when the user scrolls the page
  window.addEventListener('scroll', () => {
    if (document.querySelector('.cc-sizeOverlay.is-open')) {
      closeAllOverlays(null);
    }
  }, { passive: true });

  // Tap tracking. All passive, so they never delay or interfere with scrolling.
  window.addEventListener('touchstart', onGlobalTouchStart, { capture: true, passive: true });
  window.addEventListener('touchmove', onGlobalTouchMove, { capture: true, passive: true });
  window.addEventListener('touchcancel', onGlobalTouchCancel, { capture: true, passive: true });
  window.addEventListener('scroll', onAnyScroll, { capture: true, passive: true });

  // Use `window` capture so we fire even if something on `document` stops propagation.
  // Handle touchend first to avoid the "double tap" / "needs 2 taps" feeling on mobile.
  window.addEventListener('touchend', onGlobalTouchEnd, { capture: true, passive: false });
  window.addEventListener('click', onGlobalClick, true);
})();